import React from 'react';
import { Link } from 'react-router-dom';

const LEGAL_LINKS = [
  { to: '/legal/terms', label: 'Terms of Service' },
  { to: '/legal/privacy', label: 'Privacy Policy' },
  { to: '/legal/coppa', label: 'COPPA' },
  { to: '/legal/acceptable-use', label: 'Acceptable Use' },
  { to: '/legal/refund-cancellation', label: 'Refund Policy' },
  { to: '/legal/cookie', label: 'Cookie Policy' },
  { to: '/legal/sla', label: 'SLA' },
  { to: '/legal/safety-ai-disclaimer', label: 'Safety & AI Disclaimer' },
] as const;

interface FooterProps {
  /** Optional extra class (e.g. md:hidden for mobile-only on dashboard) */
  className?: string;
  /** Visual style variant */
  variant?: 'default' | 'landing';
}

export const Footer: React.FC<FooterProps> = ({ className = '', variant = 'default' }) => {
  const year = new Date().getFullYear();

  const base =
    variant === 'landing'
      ? 'bg-primary text-white border-t border-white/15'
      : 'border-t border-stone-200 bg-stone-50/80 text-stone-600';

  const linkClass =
    variant === 'landing'
      ? 'text-white/90 hover:text-white hover:underline focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary rounded'
      : 'text-primary hover:underline focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 rounded';

  return (
    <footer
      className={`${base} py-6 px-4 text-sm ${className}`}
      role="contentinfo"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row gap-4 sm:gap-6 items-center sm:items-end justify-between">
        <div className="text-center sm:text-left">
          <p className={variant === 'landing' ? 'text-white/80' : 'text-stone-600'}>
            © {year} HUSTLi LLC. All rights reserved.
          </p>
        </div>

        <div className="flex flex-wrap justify-center sm:justify-end gap-x-4 gap-y-2">
          <a
            href="mailto:support@hustli.app"
            className={linkClass}
          >
            Support
          </a>
          {LEGAL_LINKS.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={linkClass}
            >
              {label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
